export const WEEK_GOAL_STAT_ID = '9-17-x';
